export interface InclusionRequestStatus {
  // key: string;
  value: InclusionRequestStatusEnum;
  icon?: string;
  label?: string;
  order: number;
}

export enum InclusionRequestStatusEnum {
  Pending = 'pending',
  Declined = 'declined',
  Left = 'left',
  Accepted = 'accepted',
  Cancelled = 'cancelled',
}

export const INCLUSION_REQUEST_STATUSES: InclusionRequestStatus[] = [
  { value: InclusionRequestStatusEnum.Accepted, label: 'Actief', order: 1 },
  { value: InclusionRequestStatusEnum.Pending, label: 'Uitgenodigd', order: 2 },
  { value: InclusionRequestStatusEnum.Left, label: 'Gestopt', order: 3 },
  { value: InclusionRequestStatusEnum.Declined, label: 'Geweigerd', order: 4 },
  { value: InclusionRequestStatusEnum.Cancelled, label: 'Geannuleerd', order: 5 },
];

export function getInclusionRequestStatusses(): InclusionRequestStatus[] {
  return (
    INCLUSION_REQUEST_STATUSES
  );
}

export function getInclusionRequestStatusLabel(key?: string): string {
  return (
    INCLUSION_REQUEST_STATUSES.find((s) => s.value === key)?.label ?? 'Onbekende status'
  );
}

export function getInclusionRequestStatusIcon(key?: string): string {
  return (
    INCLUSION_REQUEST_STATUSES.find((s) => s.value === key)?.icon ?? 'info'
  );
}
